import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';

export const StyledContainer = styled(Container)`
  &:first-child {
    padding: 85px 0;
  }

  &.app-banner-video-section {
    .app-banner {
      padding: 0;
      align-items: center;
      width: 100%;

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        align-items: flex-start;
      }
    }
  }

  &.anchor-wrapper {
    padding: 0;
    margin: 0 auto;
  }
`;

export const ContentWrapper = styled.div`
  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
`;

export const SectionWrapper = styled.div``;

export const Links = styled.div`
  display: flex;
  justify-content: ${({ contentAlignment }) => contentAlignment || 'left'};
`;
